import { Injectable } from '@angular/core';
import { NotificationService } from '@progress/kendo-angular-notification';
import { take } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class BrowserCheckService {
  private patterns = [
    { regex: /Opera|OPR|OPT/, browser: 'Opera' },
    { regex: /Edg/, browser: 'Edge' },
    { regex: /Firefox/, browser: 'Firefox' },
    { regex: /MSIE|Trident/, browser: 'IE' },
  ];

  constructor(private notificationService: NotificationService) { }

  public checkBrowser(): void {
    const ua = window.navigator.userAgent;
    if (!this.isAllowedBrowser(ua)) {
      this.showBrowserWarning(ua);
    }
  }

  private isAllowedBrowser(userAgent: string): boolean {
    const isChrome = /Chrome|CriOS/.test(userAgent) && !/Edg|OPR|Opera|OPT|Firefox|MSIE|Trident/.test(userAgent);
    const isSafari = /Safari/.test(userAgent) && !/Chrome|CriOS|Edg|OPR|Opera|OPT|Firefox|MSIE|Trident/.test(userAgent);
    return isChrome || isSafari;
  }

  private showBrowserWarning(userAgent: string): void {
    const matchedPattern = this.patterns.find(({ regex }) => {
      return regex.test(userAgent);
    });

    const browser = matchedPattern?.browser || 'Unknown';

    this.notificationService.show({
      content: `For the best Vista Studio experience, please use Safari or Chrome. You are currently using ${browser}.`,
      cssClass: 'check-browser-notification',
      animation: { type: 'slide', duration: 700 },
      position: { horizontal: 'center', vertical: 'top' },
      type: { style: 'warning', icon: true },
      closable: true,
    }).afterHide.pipe(take(1)).subscribe(() => {
      this.onCloseHandler();
    });
  }

  private onCloseHandler(): void {
    localStorage.setItem('isBrowserWarningClosed', 'true');
  }
}
